module.exports = __webpack_public_path__ + "static/media/2loop3.d1b09760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2loop3.jpg
// module id = 288
// module chunks = 0